import DOMPurify from "dompurify"

// escapes text for putting into html that is shown without Angular's sanitising, such as help and tour messages.
// Names and descriptions come from what people type, so they must not be able to add markup or scripts
export const escapeHtml = (value:any) => String(value ?? '')
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;')

// an AI summary is HTML from the AI, or from whoever saved it, so anything in it that could run is taken out before it
// is trusted. Its stylesheet is kept: it is scoped to the summary
export const cleanSummaryHtml = (html:string) => DOMPurify.sanitize(html || '', {ADD_TAGS: ['style'], FORCE_BODY: true})
